import React from "react";
import { Row, Col, Card, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import mainImage from "../../assets/jui-news-image.png"; 
import card1 from "../../assets/heroes-cup.jpg";   
import card2 from "../../assets/bloom-main.jpg";     

const { Title, Paragraph, Text } = Typography;

const JiuJitsuNewsDetail = () => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate("/news");
  };

  const handleHeroesCupClick = () => {
    navigate("/news/heroes-day");
  };

  const handleBloomDayClick = () => {
    navigate("/news/bloom-day");
  };

  return (
    <div style={{ background: "#fafafa", padding: "24px" }}>
      <Row gutter={[24, 24]} justify="center">
        {/* LEFT SIDE */}
        <Col xs={24} md={8} lg={6}>
          {/* Header Card */}
          <Card
            style={{
              background: "#4b007d",
              color: "#fff",
              borderRadius: "10px",
              padding: "16px",
            }}
            bordered={false}
          >
            <Title level={4} style={{ color: "#fff", marginBottom: 4 }}>
              Yalla Nellab News
            </Title>
            <Text 
              style={{ color: "#d9d9d9", cursor: "pointer" }}
              onClick={handleViewAll}
            >
              View all
            </Text>
          </Card>

          {/* News Card 1 - Heroes Cup */}
          <Card
            hoverable
            onClick={handleHeroesCupClick}
            cover={
              <img
                alt="Heroes Cup"
                src={card1}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Heroes Cup: Tournament dedicated to honoring laborers
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>

          {/* News Card 2 - Bloom Day */}
          <Card
            hoverable
            onClick={handleBloomDayClick}
            cover={
              <img
                alt="Bloom Day"
                src={card2}
                style={{ height: 140, objectFit: "cover" }}
              />
            }
            style={{ marginTop: 16, borderRadius: 10, cursor: "pointer" }}
          >
            <Title level={5} style={{ marginBottom: 8 }}>
              Bloom Day: Yalla Nellab Announces New Initiative
            </Title>
            <Text type="secondary" style={{ fontSize: 13 }}>
              Read More →
            </Text>
          </Card>
        </Col>

        {/* RIGHT SIDE */}
        <Col xs={24} md={16} lg={18}>
          <div
            style={{
              borderRadius: 10,
              overflow: "hidden",
              position: "relative",
            }}
          >
            <img
              alt="jiu-jitsu"
              src={mainImage}
              style={{
                width: "100%",
                height: "auto",
                display: "block",
                opacity: 0.95,
              }}
            />

            {/* Article content */}
            <div
              style={{
                background: "#fff",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                padding: "24px",
                marginTop: "8px",
              }}
            >
              <Title level={3}>Jiu-jitsu is Rising in the UAE</Title>

              <Title level={5}>Introduction</Title>
              <Paragraph>
                In recent years, the martial art of Jiu-jitsu has seen remarkable growth in the
                United Arab Emirates (UAE) — an area closely tied to strategic support from the
                country's leadership.
              </Paragraph>

              <Title level={5}>Royal Patronage and Strategic Vision</Title>
              <ul>
                <li>
                  Sheikh Tahnoon bin Zayed Al Nahyan is credited as a key early proponent of
                  Jiu-jitsu in the UAE.
                </li>
                <li>
                  Sheikh Mohammed bin Zayed Al Nahyan is recognized as having given explicit backing
                  to Jiu-jitsu.
                </li>
                <li>
                  The UAE Jiu-Jitsu Federation (UAEJJF), established in November 2012, serves as the
                  national authority for Jiu-jitsu in the UAE.
                </li>
              </ul>

              <Title level={5}>Institutional & Grassroots Development</Title>
              <Paragraph>
                Jiu-jitsu has been part of educational programmes since around 2008, with more than
                140 schools reportedly offering it.
              </Paragraph>

              <Title level={5}>Competitive Success</Title>
              <ul>
                <li>
                  The UAE national Jiu-jitsu team has achieved repeated success at world
                  championships.
                </li>
                <li>
                  In 2022, the UAE team took 68 medals (26 gold, 17 silver, 20 bronze) at the World
                  Championship.
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default JiuJitsuNewsDetail;